import { render, staticRenderFns } from "./userGroup.vue?vue&type=template&id=029213f2&scoped=true"
import script from "./userGroup.vue?vue&type=script&lang=js"
export * from "./userGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029213f2",
  null
  
)

export default component.exports